// reactstrap components
import {Container} from "reactstrap";

const Footer: React.FC = () => (
  <footer className="footer">
    <Container fluid>
      <div className="copyright">TrainerDX &copy; Torque Advisory LLC {new Date().getFullYear()}</div>
    </Container>
  </footer>
);

export default Footer;
